import { VALUE_PATTERN, VALUES_PATTERN } from 'constants/general';

import type { IParamsError } from 'store/slices/dataSets/interfaces/IErrorItem';

const errorMessagesFormatted = (errorText: string, params: IParamsError) => {
  if (errorText.includes(VALUE_PATTERN) && !params.values) {
    return errorText.replace(VALUE_PATTERN, params.value);
  }

  if (errorText.includes(VALUES_PATTERN) && params.values) {
    return errorText.replace(VALUES_PATTERN, '');
  }

  return errorText;
};

export default errorMessagesFormatted;
